import { motion } from "framer-motion";
import { ArrowUpRight, Anchor } from "lucide-react";
import { SHOP_URL } from "@/lib/config";

export const ApparelSpotlight = () => (
  <section id="apparel" className="bg-[#0B111B] border-y border-[#D4AF37]/15 grain" data-testid="apparel-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col md:flex-row md:items-end md:justify-between gap-8"
      >
        <div className="max-w-2xl">
          <p className="text-[11px] tracking-[0.5em] uppercase text-[#D4AF37] flex items-center gap-3">
            <Anchor size={12} /> Captain's Cut Apparel
          </p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-[0.08em] text-[#F5F3EF] mt-3" data-testid="apparel-heading">
            MARITIME APPAREL <span className="gold-text">FOR MARITIME CREW</span>
          </h2>
        </div>
        <a href={SHOP_URL} target="_blank" rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase bg-[#D4AF37] text-[#070A0F] px-6 py-4 hover:bg-[#F3E08A] transition-colors duration-300 shrink-0"
          data-testid="apparel-shop-all-btn">
          Shop the full collection <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
        </a>
      </motion.div>
    </div>
  </section>
);
